var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import env from 'config/env';
import { UserInvite } from 'packages/authentication/UserInvite';
import { EntityBuilder } from '@/node_modules/@decahedron/entity';
var InvitationRepository = /** @class */ (function (_super) {
    __extends(InvitationRepository, _super);
    function InvitationRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = UserInvite;
        _this.baseUrl = env.JOBILLA_API_V2_URL;
        _this.url = 'invites';
        return _this;
    }
    InvitationRepository.prototype.resolveInvitation = function (token) {
        var _this = this;
        return this.get(this.url + "/" + token).then(function (response) { return EntityBuilder.buildOne(UserInvite, _this.responseTransformer(response.data)); });
    };
    InvitationRepository.prototype.inviteUser = function (name, email, language) {
        return this.post('user/jobilla/invite', { name: name, email: email, language: language })
            .then(function (response) { return EntityBuilder.buildOne(UserInvite, response); });
    };
    return InvitationRepository;
}(AbstractRepository));
export { InvitationRepository };
